export default __webpack_public_path__ + "static/media/69.76955523.jpeg";